import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/NC-Logo.png'


const _withScopeId = n => (_pushScopeId("data-v-cfc2fb22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex justify-between h-nav-mobile pl-md pr-standard border-b" }
const _hoisted_2 = {
  id: "menu-toggle",
  class: "py-standard"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "background-overlay" }, null, -1))
const _hoisted_4 = {
  id: "menu",
  class: "-ml-md"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-full ml-auto",
    src: _imports_0
  })
], -1))
const _hoisted_6 = {
  id: "nav-list",
  class: "text-2xl"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Home", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Übersicht", -1))
const _hoisted_10 = { class: "" }
const _hoisted_11 = { id: "subnav" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuOpen) = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.menuOpen]
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainNavItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.ID
            }, [
              _createElementVNode("p", {
                onClick: ($event: any) => (_ctx.selectNavItem(item)),
                class: _normalizeClass({ 'text-black font-bold': _ctx.selectedNavItem === item })
              }, _toDisplayString(item.title), 11, _hoisted_8),
              (item.child_items && item.child_items.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["child-container bg-background-darker text-lg overflow-hidden transition-all duration-300", {
                'max-h-0 py-0 opacity-0': _ctx.selectedNavItem !== item,
                'max-h-md-image py-md opacity-100': _ctx.selectedNavItem === item
              }])
                  }, [
                    _createVNode(_component_router_link, {
                      to: item.url.replace(/^https:\/\/wpdev.netconnect.ch/, '')
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child_items, (child) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        to: child.url.replace(/^https:\/\/wpdev.netconnect.ch/, ''),
                        key: child.ID
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(child.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subNavItems, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.ID
            }, [
              (item.type === 'custom')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item.url,
                    target: "_blank",
                    class: "mx-5 my-auto justify-self-end hover:underline nav-cta"
                  }, _toDisplayString(item.title), 9, _hoisted_12))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: item.url.replace(/^https:\/\/wpdev.netconnect.ch/, ''),
                    class: "main-nav-link mx-5 my-auto justify-self-end hover:underline nav-cta"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ], 64))
          }), 128))
        ])
      ]),
      _hoisted_13,
      _hoisted_14,
      _hoisted_15
    ]),
    _createElementVNode("img", {
      id: "logo",
      alt: "firmenlogo",
      class: _normalizeClass(["h-full transition-opacity duration-300", { 'opacity-0': _ctx.menuOpen }]),
      src: _imports_0
    }, null, 2)
  ]))
}